var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.460019 7.70996L6.12002 13.36C6.21298 13.4537 6.32358 13.5281 6.44544 13.5789C6.5673 13.6296 6.69801 13.6558 6.83002 13.6558C6.96203 13.6558 7.09274 13.6296 7.21459 13.5789C7.33645 13.5281 7.44706 13.4537 7.54002 13.36C7.72627 13.1726 7.83081 12.9191 7.83081 12.655C7.83081 12.3908 7.72627 12.1373 7.54002 11.95L2.59002 6.94996L7.54002 1.99996C7.72627 1.8126 7.83081 1.55915 7.83081 1.29496C7.83081 1.03078 7.72627 0.777327 7.54002 0.589964C7.4474 0.495476 7.33696 0.420305 7.21508 0.368809C7.09321 0.317312 6.96233 0.290514 6.83002 0.289965C6.69771 0.290514 6.56683 0.317312 6.44495 0.368809C6.32308 0.420305 6.21263 0.495476 6.12002 0.589964L0.460019 6.23996C0.358514 6.3336 0.277506 6.44726 0.222098 6.57376C0.16669 6.70026 0.138086 6.83686 0.138086 6.97496C0.138086 7.11307 0.16669 7.24967 0.222098 7.37617C0.277505 7.50267 0.358514 7.61632 0.460019 7.70996Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.cc990a87fb1bd0110a1d033160b4c007.svg";
export { ForwardRef as ReactComponent };